import { Injectable } from '@angular/core';
import { GlobalsService } from '../../../_core/globals.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CmpSyncService {
  constructor(
    private globalSvc: GlobalsService,
    private http: HttpClient,
  ) {}
  campaignSyncParams: any;
  apiCampaignSync: string = `${this.globalSvc.env.dxCampaignSyncUrl}/leads`;
  apiCampaignSyncLogs: string = `${this.globalSvc.env.dxCampaignSyncUrl}/ContentHubLogs`;
  apiCampaignThumbnails: string = `${this.globalSvc.env.dxCampaignSyncUrl}/thumbnaillibrary`;
  getCampaignById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiCampaignSync}/getCampaignById?campaignId=${id}`,
    );
  }
  getWhitePaperByCriteria(params: any): Observable<any> {
    // return  this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params);
    return new Observable<any>((observer) => {
      this.http
        .post<any>(`${this.apiCampaignSync}/getWhitePapersThumbnail`, params)
        .subscribe((data) => {
          observer.next(data);
        });
    });
  }

  getCampaignThumbnails(params: any): Observable<any> {
    return new Observable<any>((observer) => {
      this.http
        .post<any>(
          `${this.apiCampaignThumbnails}/getThumbnailLibraryList`,
          params,
        )
        .subscribe((data) => {
          observer.next(data);
        });
    });
  }
  generateDDGUrl(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignSync}/GenerateDDGUrl`,
      params,
    );
  }

  processWhitePaperSync(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignSync}/ProcessWhitePapersByCidDistributedThumbnail`,
      params,
    );
  }

  troubleShoot(params: any): Observable<any> {
    return this.http.post<any>(`${this.apiCampaignSync}/troubleshoot`, params);
  }
  downloadThumbFile(params: any): Observable<any> {
    return this.http.get(
      `${this.apiCampaignThumbnails}/downloadThumbnail/${params}`,
    );
  }
  revertThumbFile(thumbnailId: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignThumbnails}/revertThumbnail/${thumbnailId}`,
      {},
    );
  }
  replaceThumbFile(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignThumbnails}/UpsertThumbnailAsync`,
      data,
    );
  }
  regenerateThumbFile(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignThumbnails}/regenerateThumbnail`,
      data,
    );
  }
  addThumbFile(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignThumbnails}/addThumbnail`,
      params,
    );
  }
  SyncThumbFile(params: any): Observable<any> {
    return this.http.post<any>(`${this.apiCampaignSync}/syncThumbnail`, params);
  }
  setThumbnailLock(params: { thumbnailId: number; isLocked: boolean }): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignThumbnails}/setThumbnailLock`,
      params,
    );
  }
  RegenThumbFile(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiCampaignThumbnails}/addThumbnail`,
      params,
    );
  }
}
